import { useState, useRef } from "react";
const NEAREST_URL =
  "https://developer.nrel.gov/api/alt-fuel-stations/v1/nearby-route.json";

const fetchData = (additionalParams, signal) => {
  let params = {
    fuel_type: "ELEC",
    format: "JSON",
    // NREL API doesn't handle preflight CORS requests properly, so we have to
    // include the API key as a GET query param instead of as a header
    limit: "all",
    distance: 5,
    ...additionalParams
  };
  let url = new URL(NEAREST_URL);
  url.search = new URLSearchParams({
    api_key: process.env.REACT_APP_NREL_API_KEY
  });

  let body = new URLSearchParams(params);

  return window.fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
    },
    body,
    signal
  });
};

const useChargingStationsNearRoute = () => {
  const [loading, setLoading] = useState(false);
  const [chargingStations, setChargingStations] = useState([]);
  const [error, setError] = useState("");

  const abortControllerRef = useRef(null);

  const fetchChargingStations = async ({ route }) => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    if (!route) return;

    try {
      abortControllerRef.current = new window.AbortController();
      setLoading(true);

      const response = await fetchData(
        {
          route
        },
        abortControllerRef.current.signal
      );
      const json = await response.json();

      abortControllerRef.current = null;

      setLoading(false);
      if (json) {
        setChargingStations(json.fuel_stations);
      }
    } catch (error) {
      setLoading(false);

      if (error.name !== "AbortError") {
        setError(error);
      }
      abortControllerRef.current = null;
    }
  };

  return {
    error,
    chargingStations,
    fetchChargingStations,
    loading
  };
};

export default useChargingStationsNearRoute;
